
  <mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Share Files</h3>
              <mat-icon  class="close" (click)="closeShareOpt(closeShare)" >close</mat-icon>
          </div>
        </div>
          <div class="dialog_content">

            <div class="documentListing">

              <div class="doc">
                <div class="icon"><img src="../../../../../assets/images/icons/pdf.svg" alt=""></div>
                <div class="name">Listing Agreement</div>
                <button class="remove" mat-icon-button><mat-icon>remove_circle_outline</mat-icon></button>
              </div>
              <div class="doc">
                <div class="icon"><img src="../../../../../assets/images/icons/pdf.svg" alt=""></div>
                <div class="name">Listing Agreement</div>
                <button class="remove" mat-icon-button><mat-icon>remove_circle_outline</mat-icon></button>
              </div>
              <div class="doc">
                <div class="icon"><img src="../../../../../assets/images/icons/pdf.svg" alt=""></div>
                <div class="name">Listing Agreement</div>
                <button class="remove" mat-icon-button><mat-icon>remove_circle_outline</mat-icon></button>
              </div>

            </div>

              <form  class="fix-mat-form-field" >
                <app-contactlist></app-contactlist>
    
                <mat-form-field>
                    <mat-label>Add Message</mat-label>
                    <textarea matInput
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"></textarea>
                  </mat-form-field>
      
                  <mat-form-field>
                    <mat-label>Select Expiry Date</mat-label>
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  
                  <mat-form-field >
                    <mat-label>Add Document Password</mat-label>
                    <input matInput type="password" placeholder="Enter document password" >
                  </mat-form-field>
                  <mat-form-field >
                    <mat-label>Confirm Document Password</mat-label>
                    <input matInput type="password" placeholder="Enter document password" >
                  </mat-form-field>
                  
              </form>
      
          </div>
   
    
    <div class="actionBtn">
    
    <button mat-flat-button class="cancel" (click)="closeShareOpt(closeShare)" >Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit"  color="primary">Share</button>
    </div>
</mat-card>




<div class="overlay" (click)="closeShareOpt(closeShare)"></div>